export const initialTeam = [
  { id: 'usr-1', name: 'Sarah Jenkins', role: 'Engineering Director', avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150', email: 'sarah.j@nexusflow.io', dept: 'Engineering', workload: 85, capacity: 40 },
  { id: 'usr-2', name: 'Alex Rivera', role: 'Lead AI Architect', avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150', email: 'alex.r@nexusflow.io', dept: 'AI & ML', workload: 92, capacity: 40 },
  { id: 'usr-3', name: 'Elena Rostova', role: 'Senior UX Designer', avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=150', email: 'elena.r@nexusflow.io', dept: 'Design', workload: 65, capacity: 40 },
  { id: 'usr-4', name: 'Marcus Chen', role: 'Full Stack Engineer', avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150', email: 'marcus.c@nexusflow.io', dept: 'Engineering', workload: 78, capacity: 40 },
  { id: 'usr-5', name: 'Chloe Bennett', role: 'Product Manager', avatar: 'https://images.unsplash.com/photo-1517841905240-472988babdf9?w=150', email: 'chloe.b@nexusflow.io', dept: 'Product', workload: 50, capacity: 40 },
];

export const initialProjects = [
  {
    id: 'proj-1',
    name: 'Cloud Infrastructure Migration',
    key: 'CIM',
    description: 'Migrate core microservices from AWS to multi-cloud K8s clusters with zero downtime.',
    status: 'In Progress',
    progress: 68,
    dueDate: '2025-05-15',
    budget: '$45,000',
    priority: 'Urgent',
    lead: 'usr-1',
    category: 'Infrastructure',
    color: 'indigo'
  },
  {
    id: 'proj-2',
    name: 'Nexus Mobile App v2',
    key: 'MOB',
    description: 'Redesign iOS and Android client applications with offline sync and AI Copilot integration.',
    status: 'In Progress',
    progress: 42,
    dueDate: '2025-06-30',
    budget: '$80,000',
    priority: 'High',
    lead: 'usr-3',
    category: 'Mobile',
    color: 'emerald'
  },
  {
    id: 'proj-3',
    name: 'AI Data Pipeline Optimization',
    key: 'AIP',
    description: 'Improve embedding ingestion speed and reduce LLM inference token latency by 45%.',
    status: 'Planning',
    progress: 15,
    dueDate: '2025-07-10',
    budget: '$30,000',
    priority: 'High',
    lead: 'usr-2',
    category: 'AI & Data',
    color: 'purple'
  },
  {
    id: 'proj-4',
    name: 'E-Commerce Checkout Redesign',
    key: 'ECR',
    description: 'One-click checkout expansion supporting Apple Pay, Google Pay, and Crypto gateways.',
    status: 'Review',
    progress: 90,
    dueDate: '2025-04-20',
    budget: '$25,000',
    priority: 'Medium',
    lead: 'usr-4',
    category: 'Web',
    color: 'blue'
  }
];

export const initialTasks = [
  {
    id: 'task-101',
    projectId: 'proj-1',
    title: 'Configure Terraform scripts for multi-region failover',
    description: 'Setup automated DNS failover and state locking across us-east-1 and eu-west-1.',
    status: 'in_progress',
    priority: 'Urgent',
    assigneeId: 'usr-1',
    dueDate: '2025-04-10',
    tags: ['DevOps', 'Terraform', 'AWS'],
    estimatedHours: 24,
    loggedHours: 18,
    checklist: [
      { id: 'cl-1', text: 'Write AWS VPC peering modules', completed: true },
      { id: 'cl-2', text: 'Setup Route53 health checks', completed: true },
      { id: 'cl-3', text: 'Run staged load test on staging', completed: false }
    ],
    comments: [
      { id: 'cm-1', author: 'Sarah Jenkins', text: 'Ensure we check IAM role policies before applying.', time: '2 hours ago' }
    ]
  },
  {
    id: 'task-102',
    projectId: 'proj-1',
    title: 'Audit IAM Roles and Least Privilege Security Policies',
    description: 'Review service accounts and rotate access tokens for staging and production environments.',
    status: 'todo',
    priority: 'High',
    assigneeId: 'usr-4',
    dueDate: '2025-04-14',
    tags: ['Security', 'IAM'],
    estimatedHours: 16,
    loggedHours: 0,
    checklist: [
      { id: 'cl-4', text: 'Export current IAM policy report', completed: false },
      { id: 'cl-5', text: 'Remove unused admin roles', completed: false }
    ],
    comments: []
  },
  {
    id: 'task-103',
    projectId: 'proj-1',
    title: 'Zero-downtime database migration strategy test',
    description: 'Perform canary migration on PostgreSQL replica cluster.',
    status: 'done',
    priority: 'Urgent',
    assigneeId: 'usr-4',
    dueDate: '2025-04-02',
    tags: ['Database', 'Migration'],
    estimatedHours: 20,
    loggedHours: 20,
    checklist: [
      { id: 'cl-6', text: 'Backup prod snapshot', completed: true },
      { id: 'cl-7', text: 'Execute pg_dump & restore test', completed: true }
    ],
    comments: []
  },
  {
    id: 'task-104',
    projectId: 'proj-2',
    title: 'Implement React Native Skia animations for dashboard',
    description: 'Fluid 60FPS UI transitions for charts and card dragging.',
    status: 'in_progress',
    priority: 'High',
    assigneeId: 'usr-3',
    dueDate: '2025-04-18',
    tags: ['Mobile', 'UI/UX', 'React Native'],
    estimatedHours: 30,
    loggedHours: 12,
    checklist: [
      { id: 'cl-8', text: 'Design skeleton loaders', completed: true },
      { id: 'cl-9', text: 'Benchmark FPS on iPhone 12 & Pixel 6', completed: false }
    ],
    comments: []
  },
  {
    id: 'task-105',
    projectId: 'proj-2',
    title: 'Offline SQLite database encryption setup',
    description: 'Secure local user cache with SQLCipher.',
    status: 'backlog',
    priority: 'Medium',
    assigneeId: 'usr-4',
    dueDate: '2025-05-01',
    tags: ['Mobile', 'Security'],
    estimatedHours: 18,
    loggedHours: 0,
    checklist: [],
    comments: []
  },
  {
    id: 'task-106',
    projectId: 'proj-3',
    title: 'Vector embedding cache layer with Redis',
    description: 'Cache high-frequency prompt embeddings to reduce OpenAI API costs by 35%.',
    status: 'todo',
    priority: 'Urgent',
    assigneeId: 'usr-2',
    dueDate: '2025-04-12',
    tags: ['AI', 'Redis', 'Performance'],
    estimatedHours: 25,
    loggedHours: 4,
    checklist: [
      { id: 'cl-10', text: 'Configure Redis cluster eviction policy', completed: true },
      { id: 'cl-11', text: 'Integrate cosine similarity lookup', completed: false }
    ],
    comments: []
  },
  {
    id: 'task-107',
    projectId: 'proj-4',
    title: 'Apple Pay & Google Pay SDK integration',
    description: 'Enable frictionless mobile wallet checkout on web store.',
    status: 'review',
    priority: 'High',
    assigneeId: 'usr-4',
    dueDate: '2025-04-08',
    tags: ['Payments', 'Frontend'],
    estimatedHours: 20,
    loggedHours: 19,
    checklist: [
      { id: 'cl-12', text: 'Test Stripe sandbox payments', completed: true },
      { id: 'cl-13', text: 'Verify webhook signature verification', completed: true }
    ],
    comments: []
  }
];

export const initialWorkflows = [
  {
    id: 'wf-1',
    name: 'Auto-Assign Urgent Security Tasks',
    trigger: 'Task Created with Priority = "Urgent" & Tag = "Security"',
    action: 'Assign to Lead AI Architect & Send PagerDuty alert',
    active: true,
    executions: 142
  },
  {
    id: 'wf-2',
    name: 'PR Review Bottleneck Alert',
    trigger: 'Task in "Review" status > 48 hours',
    action: 'Notify Engineering Director & Slack channel #eng-alerts',
    active: true,
    executions: 38
  },
  {
    id: 'wf-3',
    name: 'Sprint Summary AI Digest',
    trigger: 'Every Friday at 5:00 PM',
    action: 'Generate AI project status report & email stakeholders',
    active: false,
    executions: 12
  }
];

export const initialActivities = [
  { id: 'act-1', user: 'Sarah Jenkins', action: 'moved task', target: 'Configure Terraform scripts', time: '10 mins ago', type: 'task' },
  { id: 'act-2', user: 'Alex Rivera', action: 'created AI workflow', target: 'Auto-Assign Urgent Security Tasks', time: '1 hour ago', type: 'workflow' },
  { id: 'act-3', user: 'Elena Rostova', action: 'completed checklist on', target: 'Design skeleton loaders', time: '3 hours ago', type: 'task' },
  { id: 'act-4', user: 'Marcus Chen', action: 'logged 6 hours on', target: 'Zero-downtime database migration', time: '5 hours ago', type: 'time' },
];

export const initialTimeEntries = [
  { id: 'te-1', userId: 'usr-1', projectId: 'proj-1', taskTitle: 'Configure Terraform scripts', hours: 6, date: '2025-04-06', billable: true },
  { id: 'te-2', userId: 'usr-4', projectId: 'proj-1', taskTitle: 'Zero-downtime database migration', hours: 8, date: '2025-04-05', billable: true },
  { id: 'te-3', userId: 'usr-3', projectId: 'proj-2', taskTitle: 'React Native Skia animations', hours: 5, date: '2025-04-06', billable: true },
  { id: 'te-4', userId: 'usr-2', projectId: 'proj-3', taskTitle: 'Vector embedding cache layer', hours: 4, date: '2025-04-04', billable: false },
];
